import {create} from 'zustand';
import {SalesChannel} from '../dto/model';

export type ThemeMode = 'light' | 'dark';

type HeaderState = {
  language: string;
  setLanguage: (language: string) => void;
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
};

const getInitialTheme = (): ThemeMode => {
  try {
    const savedTheme = localStorage.getItem('theme') as ThemeMode;
    if (savedTheme === 'light' || savedTheme === 'dark') {
      return savedTheme;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

export const useHeaderState = create<HeaderState>()((set) => ({
  language: '',
  setLanguage: (language) => set((state) => ({ language: language })),
  theme: getInitialTheme(),
  setTheme: (theme) => {
    try {
      localStorage.setItem('theme', theme);
    } catch {
      // Handle localStorage errors silently
    }
    set((state) => ({ theme }));
  },
}));

type SalesChannelState = {
  salesChannel: SalesChannel;
  salesChannelLabel: string;
  setSalesChannel: (salesChannel: SalesChannel) => void;
};

export const useSalesChannelState = create<SalesChannelState>((set) => ({
  salesChannel: SalesChannel.DigitalSales,
  salesChannelLabel: 'PV Digital Sales',
  setSalesChannel: (salesChannel) =>
    set((state) => ({
      salesChannel: salesChannel,
      salesChannelLabel:
        salesChannel === SalesChannel.DigitalSales
          ? 'PV Digital Sales'
          : salesChannel === SalesChannel.CrmSales
          ? 'CRM Special Channel'
          : salesChannel === SalesChannel.Revision
          ? 'PV Revision'
          : salesChannel === SalesChannel.LeadQueue
          ? 'Lead Queue'
          : salesChannel === SalesChannel.SpecialSalesChannel1
          ? 'Special Sales Channel 1'
          : salesChannel === SalesChannel.SpecialSalesChannel2
          ? 'Special Sales Channel 2'
          : salesChannel === SalesChannel.SpecialSalesChannel3
          ? 'Special Sales Channel 3'
          : salesChannel === SalesChannel.SpecialSalesChannel4
          ? 'Special Sales Channel 4'
          : salesChannel === SalesChannel.SpecialSalesChannel5
          ? 'Special Sales Channel 5'
          : 'PV Field Sales',
    })),
}));
